/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationSurchargeRuleResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationSurchargeRule.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotationSurchargeRule/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
